export default {"src":"/_next/static/media/envelope-fill.f55c8da0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};